export function sayHello () {
  if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
    const args = ['\n %c Made with ❤️ by 8 Ways %c https://www.8ways.ch/ %c %c 😘 \n\n', 'border: 1px solid #000;color: #000; background: #ec025d; padding:5px 0;', 'color: #fff; background: #003875; padding:5px 0;border: 1px solid #000;', 'background: #fff; padding:5px 0;', 'color: #b0976d; background: #fff; padding:5px 0;']
    window.console.log.apply(console, args)
  } else if (window.console) {
    window.console.log('Made with love ❤️ 8Ways.ch - https://www.8ways.ch/  😘️')
  }
}
